import { render } from "./ButtonExecCreate.vue?vue&type=template&id=3d284db4"
import script from "./ButtonExecCreate.vue?vue&type=script&lang=js"
export * from "./ButtonExecCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/futaba-photo.net/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__